import { render, staticRenderFns } from "./PatientAgeChart.vue?vue&type=template&id=64e4ce80&"
import script from "./PatientAgeChart.vue?vue&type=script&lang=js&"
export * from "./PatientAgeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports